import { useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Row, Col, Button, Carousel } from "react-bootstrap";
import { CartContext } from "../CartContext";
import { getProductData } from "../productsStore";

function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const cart = useContext(CartContext);
  const product = getProductData(id);
  const [index, setIndex] = useState(0);

  if (!product) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h2>Product not found</h2>
        <Button onClick={() => navigate("/")} style={{ backgroundColor: "#0d1b2a", color: "white", border: "none" }}>
          Back to Store
        </Button>
      </div>
    );
  }

  const productQuantity = cart.getProductQuantity(product.id);
  const images = product.images || [product.img];

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const handleThumbnailClick = (thumbnailIndex) => {
    setIndex(thumbnailIndex);
  };

  const checkout = async () => {
    // await fetch("http://localhost:4000/checkout", {
    await fetch("https://store-api.woodcashbox.com/checkout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: cart.items }),
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.url) {
          window.location.assign(response.url); // Forwarding user to Stripe
        }
      });
  };

  const hasItemsInCart = cart.items.length > 0;

  return (
    <div style={{ marginTop: "30px", marginBottom: "50px" }}>
      <Row>
        {/* Left side - Image Gallery */}
        <Col md={7}>
          <Row>
            {/* Thumbnail images on far left */}
            <Col xs={2} style={{ paddingRight: "10px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {images.map((img, idx) => (
                  <div
                    key={idx}
                    onClick={() => handleThumbnailClick(idx)}
                    style={{
                      cursor: "pointer",
                      border: index === idx ? "2px solid #000" : "2px solid transparent",
                      borderRadius: "4px",
                      padding: "2px",
                      transition: "border 0.2s",
                    }}
                  >
                    <img
                      src={img}
                      alt={`${product.title} view ${idx + 1}`}
                      style={{
                        width: "100%",
                        height: "auto",
                        borderRadius: "2px",
                        display: "block",
                      }}
                    />
                  </div>
                ))}
              </div>
            </Col>

            {/* Main product image - Bootstrap Carousel */}
            <Col xs={10}>
              <Carousel
                activeIndex={index}
                onSelect={handleSelect}
                indicators={false}
                controls={images.length > 1}
                interval={null}
                style={{ borderRadius: "8px", overflow: "hidden" }}
              >
                {images.map((img, idx) => (
                  <Carousel.Item key={idx}>
                    <img
                      className="d-block w-100"
                      src={img}
                      alt={`${product.title} ${idx + 1}`}
                      style={{
                        width: "100%",
                        height: "auto",
                        objectFit: "contain",
                        backgroundColor: "#f8f9fa",
                      }}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </Col>
          </Row>
        </Col>

        {/* Right side - Product Details */}
        <Col md={5}>
          <div style={{ paddingLeft: "30px" }}>
            <h1 style={{ fontSize: "28px", fontWeight: "bold", marginBottom: "20px", padding: "1rem", textAlign: "center" }}>
              {product.title}
            </h1>

            <div style={{ marginBottom: "30px" }}>
              <h2 style={{ fontSize: "24px", fontWeight: "600", color: "#000" }}>
                USD {product.price.toFixed(2)}
              </h2>
            </div>

            {product.description && (
              <div style={{ marginBottom: "20px" }}>
                <p style={{ fontSize: "16px", color: "#666", lineHeight: "1.6" }}>
                  {product.description}
                </p>
              </div>
            )}

            {product.details && (
              <div style={{ marginBottom: "30px" }}>
                <h3 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "10px" }}>
                  Product Details
                </h3>
                <p style={{ fontSize: "14px", color: "#666", lineHeight: "1.6" }}>
                  {product.details}
                </p>
              </div>
            )}

            {/* Quantity and Add to Cart */}
            <div style={{ marginTop: "40px" }}>
              {productQuantity > 0 ? (
                <div>
                  <div style={{ marginBottom: "15px" }}>
                    <p style={{ fontSize: "16px", marginBottom: "10px" }}>
                      In Cart: {productQuantity}
                    </p>
                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                      <Button
                        style={{ backgroundColor: "#0d1b2a", color: "white", border: "none" }}
                        onClick={() => cart.addOneToCart(product.id)}
                      >
                        +
                      </Button>
                      <Button
                        style={{ backgroundColor: "#0d1b2a", color: "white", border: "none" }}
                        onClick={() => cart.removeOneFromCart(product.id)}
                      >
                        -
                      </Button>
                    </div>
                  </div>
                </div>
              ) : null}

              <Button
                style={{
                  backgroundColor: "#0d1b2a",
                  color: "white",
                  border: "none",
                  padding: "12px 40px",
                  fontSize: "16px",
                  fontWeight: "500",
                  borderRadius: "4px",
                  width: "100%",
                  maxWidth: "300px",
                  marginBottom: hasItemsInCart ? "15px" : "0",
                }}
                onClick={() => cart.addOneToCart(product.id)}
              >
                Add to cart
              </Button>

              {hasItemsInCart && (
                <Button
                  variant="success"
                  style={{
                    padding: "12px 40px",
                    fontSize: "16px",
                    fontWeight: "500",
                    borderRadius: "4px",
                    width: "100%",
                    maxWidth: "300px",
                  }}
                  onClick={checkout}
                >
                  Checkout
                </Button>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default ProductDetail;

